export default [
  {
    id: "AE",
    full_name_locale: "United Arab Emirates",
    full_name_english: "United Arab Emirates",
    available_regions: null,
  },
  {
    id: "AD",
    full_name_locale: "Andorra",
    full_name_english: "Andorra",
    available_regions: null,
  },
  {
    id: "AG",
    full_name_locale: "Antigua and Barbuda",
    full_name_english: "Antigua and Barbuda",
    available_regions: null,
  },
  {
    id: "AM",
    full_name_locale: "Armenia",
    full_name_english: "Armenia",
    available_regions: null,
  },
  {
    id: "AR",
    full_name_locale: "Argentina",
    full_name_english: "Argentina",
    available_regions: null,
  },
  {
    id: "AT",
    full_name_locale: "Austria",
    full_name_english: "Austria",
    available_regions: null,
  },
  {
    id: "AU",
    full_name_locale: "Australia",
    full_name_english: "Australia",
    available_regions: [
      {
        code: "ACT",
        name: "Australian Capital Territory",
      },
      {
        code: "NSW",
        name: "New South Wales",
      },
      {
        code: "NT",
        name: "Northern Territory",
      },
      {
        code: "QLD",
        name: "Queensland",
      },
      {
        code: "SA",
        name: "South Australia",
      },
      {
        code: "TAS",
        name: "Tasmania",
      },
      {
        code: "VIC",
        name: "Victoria",
      },
      {
        code: "WA",
        name: "Western Australia",
      },
    ],
  },
  {
    id: "AW",
    full_name_locale: "Aruba",
    full_name_english: "Aruba",
    available_regions: null,
  },
  {
    id: "BA",
    full_name_locale: "Bosnia and Herzegovina",
    full_name_english: "Bosnia and Herzegovina",
    available_regions: null,
  },
  {
    id: "BD",
    full_name_locale: "Bangladesh",
    full_name_english: "Bangladesh",
    available_regions: null,
  },
  {
    id: "BE",
    full_name_locale: "Belgium",
    full_name_english: "Belgium",
    available_regions: null,
  },
  {
    id: "BF",
    full_name_locale: "Burkina Faso",
    full_name_english: "Burkina Faso",
    available_regions: null,
  },
  {
    id: "BG",
    full_name_locale: "Bulgaria",
    full_name_english: "Bulgaria",
    available_regions: null,
  },
  {
    id: "BM",
    full_name_locale: "Bermuda",
    full_name_english: "Bermuda",
    available_regions: null,
  },
  {
    id: "BO",
    full_name_locale: "Bolivia",
    full_name_english: "Bolivia",
    available_regions: null,
  },
  {
    id: "BQ",
    full_name_locale: "Bonaire/St Eus./Saba",
    full_name_english: "Bonaire/St Eus./Saba",
    available_regions: null,
  },
  {
    id: "BR",
    full_name_locale: "Brazil",
    full_name_english: "Brazil",
    available_regions: [
      {
        code: "TO",
        name: "Tocantins",
      },
      {
        code: "SE",
        name: "Sergipe",
      },
      {
        code: "SP",
        name: "São Paulo",
      },
      {
        code: "SC",
        name: "Santa Catarina",
      },
      {
        code: "RR",
        name: "Roraima",
      },
      {
        code: "RO",
        name: "Rondônia",
      },
      {
        code: "RS",
        name: "Rio Grande do Sul",
      },
      {
        code: "RN",
        name: "Rio Grande do Norte",
      },
      {
        code: "RJ",
        name: "Rio de Janeiro",
      },
      {
        code: "PI",
        name: "Piauí",
      },
      {
        code: "PE",
        name: "Pernambuco",
      },
      {
        code: "PR",
        name: "Paraná",
      },
      {
        code: "PB",
        name: "Paraíba",
      },
    ],
  },
  {
    id: "BS",
    full_name_locale: "Bahamas",
    full_name_english: "Bahamas",
    available_regions: null,
  },
  {
    id: "BT",
    full_name_locale: "Bhutan",
    full_name_english: "Bhutan",
    available_regions: null,
  },
  {
    id: "CA",
    full_name_locale: "Canada",
    full_name_english: "Canada",
    available_regions: [
      {
        code: "AB",
        name: "Alberta",
      },
      {
        code: "BC",
        name: "British Columbia",
      },
      {
        code: "MB",
        name: "Manitoba",
      },
      {
        code: "NB",
        name: "New Brunswick",
      },
      {
        code: "NL",
        name: "Newfoundland and Labrador",
      },
      {
        code: "NT",
        name: "Northwest Territories",
      },
      {
        code: "NS",
        name: "Nova Scotia",
      },
      {
        code: "NU",
        name: "Nunavut",
      },
      {
        code: "ON",
        name: "Ontario",
      },
      {
        code: "PE",
        name: "Prince Edward Island",
      },
      {
        code: "QC",
        name: "Quebec",
      },
      {
        code: "SK",
        name: "Saskatchewan",
      },
      {
        code: "YT",
        name: "Yukon Territory",
      },
    ],
  },
  {
    id: "CH",
    full_name_locale: "Switzerland",
    full_name_english: "Switzerland",
    available_regions: null,
  },
  {
    id: "CL",
    full_name_locale: "Chile",
    full_name_english: "Chile",
    available_regions: null,
  },
  {
    id: "CN",
    full_name_locale: "China",
    full_name_english: "China",
    available_regions: [
      {
        code: "11",
        name: "Beijing",
      },
      {
        code: "12",
        name: "Tianjin",
      },
      {
        code: "13",
        name: "Hebei",
      },
      {
        code: "14",
        name: "Shanxi",
      },
      {
        code: "15",
        name: "Nei Mongol",
      },
      {
        code: "21",
        name: "Liaoning",
      },
      {
        code: "22",
        name: "Jilin",
      },
      {
        code: "23",
        name: "Heilongjiang",
      },
      {
        code: "31",
        name: "Shanghai",
      },
      {
        code: "32",
        name: "Jiangsu",
      },
      {
        code: "33",
        name: "Zhejiang",
      },
      {
        code: "34",
        name: "Anhui",
      },
      {
        code: "35",
        name: "Fujian",
      },
      {
        code: "36",
        name: "Jiangxi",
      },
      {
        code: "37",
        name: "Shandong",
      },
      {
        code: "41",
        name: "Henan",
      },
      {
        code: "42",
        name: "Hubei",
      },
      {
        code: "43",
        name: "Hunan",
      },
      {
        code: "44",
        name: "Guangdong",
      },
      {
        code: "45",
        name: "Guangxi",
      },
      {
        code: "46",
        name: "Hainan",
      },
      {
        code: "50",
        name: "Chongqing",
      },
      {
        code: "51",
        name: "Sichuan",
      },
      {
        code: "52",
        name: "Guizhou",
      },
      {
        code: "53",
        name: "Yunnan",
      },
      {
        code: "54",
        name: "Xizang",
      },
      {
        code: "61",
        name: "Shaanxi",
      },
      {
        code: "62",
        name: "Gansu",
      },
      {
        code: "63",
        name: "Qinghai",
      },
      {
        code: "64",
        name: "Ningxia",
      },
      {
        code: "65",
        name: "Xinjiang",
      },
      {
        code: "71",
        name: "Chinese Taipei",
      },
      {
        code: "91",
        name: "Hong Kong",
      },
      {
        code: "92",
        name: "Macao",
      },
    ],
  },
  {
    id: "HK",
    full_name_locale: "Chinese HK",
    full_name_english: "Chinese HK",
    available_regions: null,
  },
  {
    id: "TW",
    full_name_locale: "Chinese Taiwan",
    full_name_english: "Chinese Taiwan",
    available_regions: null,
  },
  {
    id: "CO",
    full_name_locale: "Colombia",
    full_name_english: "Colombia",
    available_regions: null,
  },
  {
    id: "CR",
    full_name_locale: "Costa Rica",
    full_name_english: "Costa Rica",
    available_regions: null,
  },
  {
    id: "CY",
    full_name_locale: "Cyprus",
    full_name_english: "Cyprus",
    available_regions: null,
  },
  {
    id: "CZ",
    full_name_locale: "Czech Republic",
    full_name_english: "Czech Republic",
    available_regions: null,
  },
  {
    id: "DE",
    full_name_locale: "Germany",
    full_name_english: "Germany",
    available_regions: null,
  },
  {
    id: "DK",
    full_name_locale: "Denmark",
    full_name_english: "Denmark",
    available_regions: null,
  },
  {
    id: "DM",
    full_name_locale: "Dominica",
    full_name_english: "Dominica",
    available_regions: null,
  },
  {
    id: "DO",
    full_name_locale: "Dominican Republic",
    full_name_english: "Dominican Republic",
    available_regions: null,
  },
  {
    id: "EC",
    full_name_locale: "Ecuador",
    full_name_english: "Ecuador",
    available_regions: null,
  },
  {
    id: "EE",
    full_name_locale: "Estonia",
    full_name_english: "Estonia",
    available_regions: null,
  },
  {
    id: "EG",
    full_name_locale: "Egypt",
    full_name_english: "Egypt",
    available_regions: null,
  },
  {
    id: "ES",
    full_name_locale: "Spain",
    full_name_english: "Spain",
    available_regions: null,
  },
  {
    id: "FI",
    full_name_locale: "Finland",
    full_name_english: "Finland",
    available_regions: null,
  },
  {
    id: "FJ",
    full_name_locale: "Fiji",
    full_name_english: "Fiji",
    available_regions: null,
  },
  {
    id: "FR",
    full_name_locale: "France",
    full_name_english: "France",
    available_regions: null,
  },
  {
    id: "GB",
    full_name_locale: "United Kingdom",
    full_name_english: "United Kingdom",
    available_regions: null,
  },
  {
    id: "GE",
    full_name_locale: "Georgia",
    full_name_english: "Georgia",
    available_regions: null,
  },
  {
    id: "GI",
    full_name_locale: "Gibraltar",
    full_name_english: "Gibraltar",
    available_regions: null,
  },
  {
    id: "GR",
    full_name_locale: "Greece",
    full_name_english: "Greece",
    available_regions: null,
  },
  {
    id: "GL",
    full_name_locale: "Greenland",
    full_name_english: "Greenland",
    available_regions: null,
  },
  {
    id: "GU",
    full_name_locale: "Guam",
    full_name_english: "Guam",
    available_regions: null,
  },
  {
    id: "GT",
    full_name_locale: "Guatemala",
    full_name_english: "Guatemala",
    available_regions: null,
  },
  {
    id: "HN",
    full_name_locale: "Honduras",
    full_name_english: "Honduras",
    available_regions: null,
  },
  {
    id: "HR",
    full_name_locale: "Croatia",
    full_name_english: "Croatia",
    available_regions: null,
  },
  {
    id: "HT",
    full_name_locale: "Haiti",
    full_name_english: "Haiti",
    available_regions: null,
  },
  {
    id: "HU",
    full_name_locale: "Hungary",
    full_name_english: "Hungary",
    available_regions: null,
  },
  {
    id: "ID",
    full_name_locale: "Indonesia",
    full_name_english: "Indonesia",
    available_regions: null,
  },
  {
    id: "IE",
    full_name_locale: "Ireland",
    full_name_english: "Ireland",
    available_regions: [
      {
        code: "CE",
        name: "Clare",
      },
      {
        code: "CN",
        name: "Cavan",
      },
      {
        code: "CO",
        name: "Cork",
      },
      {
        code: "CW",
        name: "Carlow",
      },
      {
        code: "D",
        name: "Dublin",
      },
      {
        code: "DL",
        name: "Donegal",
      },
      {
        code: "G",
        name: "Galway",
      },
      {
        code: "KE",
        name: "Kildare",
      },
      {
        code: "KK",
        name: "Kilkenny",
      },
      {
        code: "KY",
        name: "Kerry",
      },
      {
        code: "LD",
        name: "Longford",
      },
      {
        code: "LH",
        name: "Louth",
      },
      {
        code: "LK",
        name: "Limerick",
      },
      {
        code: "LM",
        name: "Leitrim",
      },
      {
        code: "LS",
        name: "Laois",
      },
      {
        code: "MH",
        name: "Meath",
      },
      {
        code: "MN",
        name: "Monaghan",
      },
      {
        code: "MO",
        name: "Mayo",
      },
      {
        code: "OY",
        name: "Offaly",
      },
      {
        code: "RN",
        name: "Roscommon",
      },
      {
        code: "Sligo",
        name: "SO",
      },
      {
        code: "TA",
        name: "Tipperary",
      },
      {
        code: "WD",
        name: "Waterford",
      },
      {
        code: "WH",
        name: "Westmeath",
      },
      {
        code: "WW",
        name: "Wicklow",
      },
      {
        code: "WX",
        name: "Wexford",
      },
    ],
  },
  {
    id: "IL",
    full_name_locale: "Israel",
    full_name_english: "Israel",
    available_regions: null,
  },
  {
    id: "IN",
    full_name_locale: "India",
    full_name_english: "India",
    available_regions: [
      {
        code: "AN",
        name: "Andaman and Nicobar Islands",
      },
      {
        code: "AP",
        name: "Andhra Pradesh",
      },
      {
        code: "AR",
        name: "Arunachal Pradesh",
      },
      {
        code: "AS",
        name: "Assam",
      },
      {
        code: "BR",
        name: "Bihar",
      },
      {
        code: "CH",
        name: "Chandigarh",
      },
      {
        code: "CT",
        name: "Chhattisgarh",
      },
      {
        code: "DD",
        name: "Daman and Diu",
      },
      {
        code: "DL",
        name: "Delhi",
      },
      {
        code: "DN",
        name: "Dadra and Nagar Haveli",
      },
      {
        code: "GA",
        name: "Goa",
      },
      {
        code: "GJ",
        name: "Gujarat",
      },
      {
        code: "HP",
        name: "Himachal Pradesh",
      },
      {
        code: "HR",
        name: "Haryana",
      },
      {
        code: "JH",
        name: "Jharkhand",
      },
      {
        code: "JK",
        name: "Jammu and Kashmir",
      },
      {
        code: "KA",
        name: "Karnataka",
      },
      {
        code: "KL",
        name: "Kerala",
      },
      {
        code: "LD",
        name: "Lakshadweep",
      },
      {
        code: "MH",
        name: "Maharashtra",
      },
      {
        code: "ML",
        name: "Meghalaya",
      },
      {
        code: "MN",
        name: "Manipur",
      },
      {
        code: "MP",
        name: "Madhya Pradesh",
      },
      {
        code: "MZ",
        name: "Mizoram",
      },
      {
        code: "NL",
        name: "Nagaland",
      },
      {
        code: "OR",
        name: "Odisha",
      },
      {
        code: "PB",
        name: "Punjab",
      },
      {
        code: "PY",
        name: "Puducherry",
      },
      {
        code: "RJ",
        name: "Rajasthan",
      },
      {
        code: "SK",
        name: "Sikkim",
      },
      {
        code: "TN",
        name: "Tamil Nadu",
      },
      {
        code: "TR",
        name: "Tripura",
      },
      {
        code: "UP",
        name: "Uttar Pradesh",
      },
      {
        code: "UT",
        name: "Uttarakhand",
      },
      {
        code: "WB",
        name: "West Bengal",
      },
    ],
  },
  {
    id: "IO",
    full_name_locale: "British Indian Ocean Territory",
    full_name_english: "British Indian Ocean Territory",
    available_regions: null,
  },
  {
    id: "IQ",
    full_name_locale: "Iraq",
    full_name_english: "Iraq",
    available_regions: null,
  },
  {
    id: "IS",
    full_name_locale: "Iceland",
    full_name_english: "Iceland",
    available_regions: null,
  },
  {
    id: "IT",
    full_name_locale: "Italy",
    full_name_english: "Italy",
    available_regions: [
      {
        code: "AG",
        name: "Agrigento",
      },
      {
        code: "AL",
        name: "Alessandria",
      },
      {
        code: "AN",
        name: "Ancona",
      },
      {
        code: "AO",
        name: "Aosta",
      },
      {
        code: "AR",
        name: "Arezzo",
      },
      {
        code: "AP",
        name: "Ascoli-Piceno",
      },
      {
        code: "AT",
        name: "Asti",
      },
      {
        code: "AV",
        name: "Avellino",
      },
      {
        code: "BA",
        name: "Bari",
      },
      {
        code: "BT",
        name: "Barletta-Andria-Trani",
      },
      {
        code: "BL",
        name: "Belluno",
      },
      {
        code: "BN",
        name: "Benevento",
      },
      {
        code: "BG",
        name: "Bergamo",
      },
      {
        code: "BI",
        name: "Biella",
      },
      {
        code: "BO",
        name: "Bologna",
      },
      {
        code: "BZ",
        name: "Bolzano",
      },
      {
        code: "BS",
        name: "Brescia",
      },
      {
        code: "BR",
        name: "Brindisi",
      },
      {
        code: "CA",
        name: "Cagliari",
      },
      {
        code: "CL",
        name: "Caltanissetta",
      },
      {
        code: "CB",
        name: "Campobasso",
      },
      {
        code: "CI",
        name: "Carbonia Iglesias",
      },
      {
        code: "CE",
        name: "Caserta",
      },
      {
        code: "CT",
        name: "Catania",
      },
      {
        code: "CZ",
        name: "Catanzaro",
      },
      {
        code: "CH",
        name: "Chieti",
      },
      {
        code: "CO",
        name: "Como",
      },
      {
        code: "CS",
        name: "Cosenza",
      },
      {
        code: "CR",
        name: "Cremona",
      },
      {
        code: "KR",
        name: "Crotone",
      },
      {
        code: "CN",
        name: "Cuneo",
      },
      {
        code: "EN",
        name: "Enna",
      },
      {
        code: "FM",
        name: "Fermo",
      },
      {
        code: "FE",
        name: "Ferrara",
      },
      {
        code: "FI",
        name: "Firenze",
      },
      {
        code: "FG",
        name: "Foggia",
      },
      {
        code: "FC",
        name: "Forli-Cesena",
      },
      {
        code: "FR",
        name: "Frosinone",
      },
      {
        code: "GE",
        name: "Genova",
      },
      {
        code: "GO",
        name: "Gorizia",
      },
      {
        code: "GR",
        name: "Grosseto",
      },
      {
        code: "IM",
        name: "Imperia",
      },
      {
        code: "IS",
        name: "Isernia",
      },
      {
        code: "AQ",
        name: "L'Aquila",
      },
      {
        code: "SP",
        name: "La-Spezia",
      },
      {
        code: "LT",
        name: "Latina",
      },
      {
        code: "LE",
        name: "Lecce",
      },
      {
        code: "LC",
        name: "Lecco",
      },
      {
        code: "LI",
        name: "Livorno",
      },
      {
        code: "LO",
        name: "Lodi",
      },
      {
        code: "LU",
        name: "Lucca",
      },
      {
        code: "MC",
        name: "Macerata",
      },
      {
        code: "MN",
        name: "Mantova",
      },
      {
        code: "MS",
        name: "Massa-Carrara",
      },
      {
        code: "MT",
        name: "Matera",
      },
      {
        code: "VS",
        name: "Medio Campidano",
      },
      {
        code: "ME",
        name: "Messina",
      },
      {
        code: "MI",
        name: "Milano",
      },
      {
        code: "MO",
        name: "Modena",
      },
      {
        code: "MB",
        name: "Monza-Brianza",
      },
      {
        code: "NA",
        name: "Napoli",
      },
      {
        code: "NO",
        name: "Novara",
      },
      {
        code: "NU",
        name: "Nuoro",
      },
      {
        code: "OG",
        name: "Ogliastra",
      },
      {
        code: "OT",
        name: "Olbia Tempio",
      },
      {
        code: "OR",
        name: "Oristano",
      },
      {
        code: "PD",
        name: "Padova",
      },
      {
        code: "PA",
        name: "Palermo",
      },
      {
        code: "PR",
        name: "Parma",
      },
      {
        code: "PV",
        name: "Pavia",
      },
      {
        code: "PG",
        name: "Perugia",
      },
      {
        code: "PU",
        name: "Pesaro-Urbino",
      },
      {
        code: "PE",
        name: "Pescara",
      },
      {
        code: "PC",
        name: "Piacenza",
      },
      {
        code: "PI",
        name: "Pisa",
      },
      {
        code: "PT",
        name: "Pistoia",
      },
      {
        code: "PN",
        name: "Pordenone",
      },
      {
        code: "PZ",
        name: "Potenza",
      },
      {
        code: "PO",
        name: "Prato",
      },
      {
        code: "RG",
        name: "Ragusa",
      },
      {
        code: "RA",
        name: "Ravenna",
      },
      {
        code: "RC",
        name: "Reggio-Calabria",
      },
      {
        code: "RE",
        name: "Reggio-Emilia",
      },
      {
        code: "RI",
        name: "Rieti",
      },
      {
        code: "RN",
        name: "Rimini",
      },
      {
        code: "RM",
        name: "Roma",
      },
      {
        code: "RO",
        name: "Rovigo",
      },
      {
        code: "SA",
        name: "Salerno",
      },
      {
        code: "SS",
        name: "Sassari",
      },
      {
        code: "SV",
        name: "Savona",
      },
      {
        code: "SI",
        name: "Siena",
      },
      {
        code: "SR",
        name: "Siracusa",
      },
      {
        code: "SO",
        name: "Sondrio",
      },
      {
        code: "TA",
        name: "Taranto",
      },
      {
        code: "TE",
        name: "Teramo",
      },
      {
        code: "TR",
        name: "Terni",
      },
      {
        code: "TO",
        name: "Torino",
      },
      {
        code: "TP",
        name: "Trapani",
      },
      {
        code: "TN",
        name: "Trento",
      },
      {
        code: "TV",
        name: "Treviso",
      },
      {
        code: "TS",
        name: "Trieste",
      },
      {
        code: "UD",
        name: "Udine",
      },
      {
        code: "VA",
        name: "Varese",
      },
      {
        code: "VE",
        name: "Venezia",
      },
      {
        code: "VB",
        name: "Verbania",
      },
      {
        code: "VC",
        name: "Vercelli",
      },
      {
        code: "VR",
        name: "Verona",
      },
      {
        code: "VV",
        name: "Vibo-Valentia",
      },
      {
        code: "VI",
        name: "Vicenza",
      },
      {
        code: "VT",
        name: "Viterbo",
      },
    ],
  },
  {
    id: "JM",
    full_name_locale: "Jamaica",
    full_name_english: "Jamaica",
    available_regions: null,
  },
  {
    id: "JO",
    full_name_locale: "Jordan",
    full_name_english: "Jordan",
    available_regions: null,
  },
  {
    id: "JP",
    full_name_locale: "Japan",
    full_name_english: "Japan",
    available_regions: null,
  },
  {
    id: "KG",
    full_name_locale: "Kyrgyzstan",
    full_name_english: "Kyrgyzstan",
    available_regions: null,
  },
  {
    id: "KH",
    full_name_locale: "Cambodia",
    full_name_english: "Cambodia",
    available_regions: null,
  },
  {
    id: "KN",
    full_name_locale: "Saint Kitts and Nevis",
    full_name_english: "Saint Kitts and Nevis",
    available_regions: null,
  },
  {
    id: "KP",
    full_name_locale: "Korea, D.P.R",
    full_name_english: "Korea, D.P.R",
    available_regions: null,
  },
  {
    id: "KR",
    full_name_locale: "Korea",
    full_name_english: "Korea",
    available_regions: null,
  },
  {
    id: "KW",
    full_name_locale: "Kuwait",
    full_name_english: "Kuwait",
    available_regions: null,
  },
  {
    id: "KY",
    full_name_locale: "Cayman Islands",
    full_name_english: "Cayman Islands",
    available_regions: null,
  },
  {
    id: "KZ",
    full_name_locale: "Kazakhstan",
    full_name_english: "Kazakhstan",
    available_regions: null,
  },
  {
    id: "LA",
    full_name_locale: "Laos",
    full_name_english: "Laos",
    available_regions: null,
  },
  {
    id: "LB",
    full_name_locale: "Lebanon",
    full_name_english: "Lebanon",
    available_regions: null,
  },
  {
    id: "LI",
    full_name_locale: "Liechtenstein",
    full_name_english: "Liechtenstein",
    available_regions: null,
  },
  {
    id: "LT",
    full_name_locale: "Lithuania",
    full_name_english: "Lithuania",
    available_regions: null,
  },
  {
    id: "LU",
    full_name_locale: "Luxembourg",
    full_name_english: "Luxembourg",
    available_regions: null,
  },
  {
    id: "LV",
    full_name_locale: "Latvia",
    full_name_english: "Latvia",
    available_regions: null,
  },
  {
    id: "MA",
    full_name_locale: "Morocco",
    full_name_english: "Morocco",
    available_regions: null,
  },
  {
    id: "MK",
    full_name_locale: "Macedonia",
    full_name_english: "Macedonia",
    available_regions: null,
  },
  {
    id: "MH",
    full_name_locale: "Marshall Islands",
    full_name_english: "Marshall Islands",
    available_regions: null,
  },
  {
    id: "MM",
    full_name_locale: "Myanmar",
    full_name_english: "Myanmar",
    available_regions: null,
  },
  {
    id: "MP",
    full_name_locale: "Northern Mariana Island",
    full_name_english: "Northern Mariana Island",
    available_regions: null,
  },
  {
    id: "MT",
    full_name_locale: "Malta",
    full_name_english: "Malta",
    available_regions: null,
  },
  {
    id: "MX",
    full_name_locale: "Mexico",
    full_name_english: "Mexico",
    available_regions: [
      {
        code: "AG",
        name: "Aguascalientes",
      },
      {
        code: "BC",
        name: "Baja California",
      },
      {
        code: "BS",
        name: "Baja California Sur",
      },
      {
        code: "CH",
        name: "Chihuahua",
      },
      {
        code: "CL",
        name: "Colima",
      },
      {
        code: "CM",
        name: "Campeche",
      },
      {
        code: "CO",
        name: "Coahuila",
      },
      {
        code: "CS",
        name: "Chiapas",
      },
      {
        code: "DF",
        name: "Federal District",
      },
      {
        code: "DG",
        name: "Durango",
      },
      {
        code: "GR",
        name: "Guerrero",
      },
      {
        code: "GT",
        name: "Guanajuato",
      },
      {
        code: "HG",
        name: "Hidalgo",
      },
      {
        code: "JA",
        name: "Jalisco",
      },
      {
        code: "ME",
        name: "Mexico State",
      },
      {
        code: "MI",
        name: "Michoacán",
      },
      {
        code: "MO",
        name: "Morelos",
      },
      {
        code: "NA",
        name: "Nayarit",
      },
      {
        code: "NL",
        name: "Nuevo León",
      },
      {
        code: "OA",
        name: "Oaxaca",
      },
      {
        code: "PB",
        name: "Puebla",
      },
      {
        code: "QE",
        name: "Querétaro",
      },
      {
        code: "QR",
        name: "Quintana Roo",
      },
      {
        code: "SI",
        name: "Sinaloa",
      },
      {
        code: "SL",
        name: "San Luis Potosí",
      },
      {
        code: "SO",
        name: "Sonora",
      },
      {
        code: "TB",
        name: "Tabasco",
      },
      {
        code: "TL",
        name: "Tlaxcala",
      },
      {
        code: "TM",
        name: "Tamaulipas",
      },
      {
        code: "VE",
        name: "Veracruz",
      },
      {
        code: "YU",
        name: "Yucatán",
      },
      {
        code: "ZA",
        name: "Zacatecas",
      },
    ],
  },
  {
    id: "MY",
    full_name_locale: "Malaysia",
    full_name_english: "Malaysia",
    available_regions: null,
  },
  {
    id: "NI",
    full_name_locale: "Nicaragua",
    full_name_english: "Nicaragua",
    available_regions: null,
  },
  {
    id: "NL",
    full_name_locale: "Netherlands",
    full_name_english: "Netherlands",
    available_regions: null,
  },
  {
    id: "NO",
    full_name_locale: "Norway",
    full_name_english: "Norway",
    available_regions: null,
  },
  {
    id: "NZ",
    full_name_locale: "New Zealand",
    full_name_english: "New Zealand",
    available_regions: null,
  },
  {
    id: "PA",
    full_name_locale: "Panama",
    full_name_english: "Panama",
    available_regions: null,
  },
  {
    id: "PE",
    full_name_locale: "Peru",
    full_name_english: "Peru",
    available_regions: null,
  },
  {
    id: "PG",
    full_name_locale: "Papua New Guinea",
    full_name_english: "Papua New Guinea",
    available_regions: null,
  },
  {
    id: "PH",
    full_name_locale: "Philippines",
    full_name_english: "Philippines",
    available_regions: null,
  },
  {
    id: "PK",
    full_name_locale: "Pakistan",
    full_name_english: "Pakistan",
    available_regions: null,
  },
  {
    id: "PL",
    full_name_locale: "Poland",
    full_name_english: "Poland",
    available_regions: null,
  },
  {
    id: "PR",
    full_name_locale: "Puerto Rico",
    full_name_english: "Puerto Rico",
    available_regions: null,
  },
  {
    id: "PT",
    full_name_locale: "Portugal",
    full_name_english: "Portugal",
    available_regions: null,
  },
  {
    id: "PY",
    full_name_locale: "Paraguay",
    full_name_english: "Paraguay",
    available_regions: null,
  },
  {
    id: "RO",
    full_name_locale: "Romania",
    full_name_english: "Romania",
    available_regions: null,
  },
  {
    id: "RS",
    full_name_locale: "Serbia",
    full_name_english: "Serbia",
    available_regions: null,
  },
  {
    id: "RU",
    full_name_locale: "Russia",
    full_name_english: "Russia",
    available_regions: null,
  },
  {
    id: "SA",
    full_name_locale: "Saudi Arabia",
    full_name_english: "Saudi Arabia",
    available_regions: null,
  },
  {
    id: "SE",
    full_name_locale: "Sweden",
    full_name_english: "Sweden",
    available_regions: null,
  },
  {
    id: "SG",
    full_name_locale: "Singapore",
    full_name_english: "Singapore",
    available_regions: null,
  },
  {
    id: "SI",
    full_name_locale: "Slovenia",
    full_name_english: "Slovenia",
    available_regions: null,
  },
  {
    id: "SK",
    full_name_locale: "Slovakia",
    full_name_english: "Slovakia",
    available_regions: null,
  },
  {
    id: "SL",
    full_name_locale: "Sierra Leone",
    full_name_english: "Sierra Leone",
    available_regions: null,
  },
  {
    id: "SV",
    full_name_locale: "El Salvador",
    full_name_english: "El Salvador",
    available_regions: null,
  },
  {
    id: "SZ",
    full_name_locale: "Swaziland",
    full_name_english: "Swaziland",
    available_regions: null,
  },
  {
    id: "TH",
    full_name_locale: "Thailand",
    full_name_english: "Thailand",
    available_regions: null,
  },
  {
    id: "TN",
    full_name_locale: "Tunisia",
    full_name_english: "Tunisia",
    available_regions: null,
  },
  {
    id: "TR",
    full_name_locale: "Turkey",
    full_name_english: "Turkey",
    available_regions: null,
  },
  {
    id: "TT",
    full_name_locale: "Trinidad and Tobago",
    full_name_english: "Trinidad and Tobago",
    available_regions: null,
  },
  {
    id: "TZ",
    full_name_locale: "Tanzania",
    full_name_english: "Tanzania",
    available_regions: null,
  },
  {
    id: "UA",
    full_name_locale: "Ukraine",
    full_name_english: "Ukraine",
    available_regions: null,
  },
  {
    id: "US",
    full_name_locale: "United States",
    full_name_english: "United States",
    available_regions: [
      {
        code: "AL",
        name: "Alabama",
      },
      {
        code: "AK",
        name: "Alaska",
      },
      {
        code: "AZ",
        name: "Arizona",
      },
      {
        code: "AR",
        name: "Arkansas",
      },
      {
        code: "AA",
        name: "Armed Forces America",
      },
      {
        code: "AE",
        name: "Armed Forces Europe",
      },
      {
        code: "AP",
        name: "Armed Forces Pacific",
      },
      {
        code: "CA",
        name: "California",
      },
      {
        code: "CO",
        name: "Colorado",
      },
      {
        code: "CT",
        name: "Connecticut",
      },
      {
        code: "DE",
        name: "Delaware",
      },
      {
        code: "DC",
        name: "District of Columbia",
      },
      {
        code: "FL",
        name: "Florida",
      },
      {
        code: "GA",
        name: "Georgia",
      },
      {
        code: "HI",
        name: "Hawaii",
      },
      {
        code: "ID",
        name: "Idaho",
      },
      {
        code: "IL",
        name: "Illinois",
      },
      {
        code: "IN",
        name: "Indiana",
      },
      {
        code: "IA",
        name: "Iowa",
      },
      {
        code: "KS",
        name: "Kansas",
      },
      {
        code: "KY",
        name: "Kentucky",
      },
      {
        code: "LA",
        name: "Louisiana",
      },
      {
        code: "ME",
        name: "Maine",
      },
      {
        code: "MD",
        name: "Maryland",
      },
      {
        code: "MA",
        name: "Massachusetts",
      },
      {
        code: "MI",
        name: "Michigan",
      },
      {
        code: "MN",
        name: "Minnesota",
      },
      {
        code: "MS",
        name: "Mississippi",
      },
      {
        code: "MO",
        name: "Missouri",
      },
      {
        code: "MT",
        name: "Montana",
      },
      {
        code: "NE",
        name: "Nebraska",
      },
      {
        code: "NV",
        name: "Nevada",
      },
      {
        code: "NH",
        name: "New Hampshire",
      },
      {
        code: "NJ",
        name: "New Jersey",
      },
      {
        code: "NM",
        name: "New Mexico",
      },
      {
        code: "NY",
        name: "New York",
      },
      {
        code: "NC",
        name: "North Carolina",
      },
      {
        code: "ND",
        name: "North Dakota",
      },
      {
        code: "OH",
        name: "Ohio",
      },
      {
        code: "OK",
        name: "Oklahoma",
      },
      {
        code: "OR",
        name: "Oregon",
      },
      {
        code: "PA",
        name: "Pennsylvania",
      },
      {
        code: "RI",
        name: "Rhode Island",
      },
      {
        code: "SC",
        name: "South Carolina",
      },
      {
        code: "SD",
        name: "South Dakota",
      },
      {
        code: "TN",
        name: "Tennessee",
      },
      {
        code: "TX",
        name: "Texas",
      },
      {
        code: "UT",
        name: "Utah",
      },
      {
        code: "VT",
        name: "Vermont",
      },
      {
        code: "VA",
        name: "Virginia",
      },
      {
        code: "WA",
        name: "Washington State",
      },
      {
        code: "WV",
        name: "West Virginia",
      },
      {
        code: "WI",
        name: "Wisconsin",
      },
      {
        code: "WY",
        name: "Wyoming",
      },
    ],
  },
  {
    id: "UY",
    full_name_locale: "Uruguay",
    full_name_english: "Uruguay",
    available_regions: null,
  },
  {
    id: "VE",
    full_name_locale: "Venezuela",
    full_name_english: "Venezuela",
    available_regions: null,
  },
  {
    id: "VI",
    full_name_locale: "Virgin Island, US",
    full_name_english: "Virgin Island, US",
    available_regions: null,
  },
  {
    id: "VN",
    full_name_locale: "Vietnam",
    full_name_english: "Vietnam",
    available_regions: null,
  },
  {
    id: "ZA",
    full_name_locale: "South Africa",
    full_name_english: "South Africa",
    available_regions: null,
  }
];
